
export const checkIsValidUser = async (userId: string) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/getuser`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ userId }),
  });

  if (!response.ok) {
    throw new Error('Error checking user validity');
  }

  return await response.json();
};

export const fetchLocalUser = async (searchTerm: string) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/searchusers`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ searchTerm }),
  });

  if (!response.ok) {
    throw new Error('Error fetching local  user');
  }

  return await response.json();
};
